const _ = require('lodash')

const getTagsPageUrl = (tag) => (page) =>
  page > 1 ? `/tags/${_.kebabCase(tag)}/${page}/` : `/tags/${_.kebabCase(tag)}/`

const getCategoriesPageUrl = (category) => (page) =>
  page > 1
    ? `/categories/${_.kebabCase(category)}/${page}/`
    : `/categories/${_.kebabCase(category)}/`

const getPostsPageUrl = (page) => (page > 1 ? `/pages/${page}/` : '/')

module.exports = {
  getTagsPageUrl,
  getCategoriesPageUrl,
  getPostsPageUrl,
}
